__webpack_require__.p = "/assets/turbo/c71b5abb/ottonl/_next/";